import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { connect, useDispatch } from "react-redux";
import { getSortedProducts, getSortedProductsNew } from "../../helpers/product";
import ShopSidebar from "../../wrappers/product/ShopSidebar";
import ShopTopbar from "../../wrappers/product/ShopTopbar";
import ShopProducts from "../../wrappers/product/ShopProducts";
import LayoutThree from "../../layouts/LayoutThree";
import { saveUser } from "../../redux/actions/userAction";
import {
  fetchProductsNoResult,
  saveProducts,
} from "../../redux/actions/productsAction";
import { useToasts } from "react-toast-notifications";
import { animateScroll } from "react-scroll";
import Paginator from "../../components/Paginator";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ShopProductCategory from "../../wrappers/product/ShopProductCategory";
import ShopProductSubCategory from "../../wrappers/product/ShopProductSubCategory";
import ShopProductTag from "../../wrappers/product/ShopProductTag";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ShopProductBrands from "../../wrappers/product/ShopProductBrands";

const ShopGridFullWidth = ({ location, products, userData }) => {
  const isLoggedUser =
    userData?.user?.user &&
    (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge)
      ? true
      : false;

  const visualizzaPrezzi = isLoggedUser || global.visualizzaPrezziLogOut;
  const visualizzaGriglia = isLoggedUser || global.visualizzaGrigliaLogOut;
  const visualizzaQuantita = isLoggedUser || global.visualizzaQuantitaLogOut;

  const prodottiSenzaLogin = true;
  const routeParams = useParams();

  const query = new URLSearchParams(location.search);
  const name = query.get("name");
  const { addToast } = useToasts();
  const dispatch = useDispatch();
  const [layout, setLayout] = useState("grid three-column");
  const [sortType, setSortType] = useState("");
  const [sortValue, setSortValue] = useState("");
  const [sortValues, setSortValues] = useState({});
  const [filterSortType, setFilterSortType] = useState("");
  const [filterSortValue, setFilterSortValue] = useState("");
  const [offset, setOffset] = useState(
    localStorage.getItem("currentPage")
      ? parseInt(localStorage.getItem("currentPage")) - 1
      : 0
  );
  const [currentPage, setCurrentPage] = useState(
    localStorage.getItem("currentPage")
      ? parseInt(localStorage.getItem("currentPage"))
      : 1
  );
  const [currentData, setCurrentData] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [promo, setPromo] = useState(false);
  const pageLimit = 42;
  const { pathname } = location;
  //const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  var strings = require("../../translations/italian.json");
  const history = useHistory();

  const getLayout = (layout) => {
    setLayout(layout);
  };

  useEffect(() => {
    let jNew = {};
    //console.log(routeParams)
    //; if (!routeParams?.search || routeParams?.search.length === 0) return;
    try {
      jNew =
        !routeParams?.search || routeParams?.search.length === 0
          ? {}
          : JSON.parse(
              '{"' +
                decodeURIComponent(routeParams.search)
                  .replace(/"/g, '\\"')
                  .replace(/&/g, '","')
                  .replace(/=/g, '":"') +
                '"}'
            );
    } catch (error) {
      //console.log(routeParams.search)
    }

    /*const jRouteParams = {"brands": ['JHK','VALENTO'],
                         "category":["GILET"],
                         "subcategory":["ALTA VISIBILITA'"],
                         "templates":["MANICA CORTA", "MANICA LUNGA", "CANOTTA"]};*/

    if (
      Object.keys(jNew).length === 0 &&
      sessionStorage.getItem("filter") === "{}"
    )
      return;
    const {
      brands,
      category,
      subcategory,
      templates,
      tag,
      size,
      color,
      promo,
    } = jNew;
    setPromo(promo === "SI");
    const _brands = !brands
      ? []
      : JSON.parse(
          '["' +
            brands
              .replaceAll("+", " ")
              .replaceAll(",", '", "')
              .replaceAll("%20", '", "') +
            '"' +
            "]"
        );
    const _category = !category
      ? []
      : JSON.parse(
          '["' +
            category
              .replaceAll("+", " ")
              .replaceAll(",", '", "')
              .replaceAll("%20", '", "') +
            '"' +
            "]"
        );
    const _subcategory = !subcategory
      ? []
      : JSON.parse(
          '["' +
            subcategory
              .replaceAll("+", " ")
              .replaceAll(",", '", "')
              .replaceAll("%20", '", "') +
            '"' +
            "]"
        );
    const _templates = !templates
      ? []
      : JSON.parse(
          '["' +
            templates
              .replaceAll("+", " ")
              .replaceAll(",", '", "')
              .replaceAll("%20", '", "') +
            '"' +
            "]"
        );
    const _tag = !tag
      ? []
      : JSON.parse(
          '["' +
            tag
              .replaceAll("+", " ")
              .replaceAll(",", '", "')
              .replaceAll("%20", '", "') +
            '"' +
            "]"
        );
    const _size = !size
      ? []
      : JSON.parse(
          '["' +
            size
              .replaceAll("+", " ")
              .replaceAll(",", '", "')
              .replaceAll("%20", '", "') +
            '"' +
            "]"
        );
    const _color = !color
      ? []
      : JSON.parse(
          '["' +
            color
              .replaceAll("+", " ")
              .replaceAll(",", '", "')
              .replaceAll("%20", '", "') +
            '"' +
            "]"
        );

    let sBrands = "";
    let sCategory = "";
    let sSubcategory = "";
    let sTemplates = "";
    let sTag = "";
    let sSize = "";
    let sColor = "";

    if (_brands?.forEach)
      _brands.forEach((element) => (sBrands += "|" + element));
    if (_category?.forEach)
      _category.forEach((element) => (sCategory += "|" + element));
    if (_subcategory?.forEach)
      _subcategory.forEach((element) => (sSubcategory += "|" + element));
    if (_templates?.forEach)
      _templates.forEach((element) => (sTemplates += "|" + element));
    if (_tag?.forEach) _tag.forEach((element) => (sTag += "|" + element));
    if (_size?.forEach) _size.forEach((element) => (sSize += "|" + element));
    if (_color?.forEach) _color.forEach((element) => (sColor += "|" + element));

    if (sBrands.length > 0) sBrands = sBrands.substr(1);
    if (sCategory.length > 0) sCategory = sCategory.substr(1);
    if (sSubcategory.length > 0) sSubcategory = sSubcategory.substr(1);
    if (sTemplates.length > 0) sTemplates = sTemplates.substr(1);
    if (sTag.length > 0) sTag = sTag.substr(1);
    if (sSize.length > 0) sSize = sSize.substr(1);
    if (sColor.length > 0) sColor = sColor.substr(1);

    let newJRouteParams = {};
    if (sBrands.length > 0) newJRouteParams.brands = sBrands;
    if (sCategory.length > 0) newJRouteParams.category = sCategory;
    if (sSubcategory.length > 0) newJRouteParams.subcategory = sSubcategory;
    if (sTemplates.length > 0) newJRouteParams.templates = sTemplates;
    if (sTag.length > 0) newJRouteParams.tag = sTag;
    if (sSize.length > 0) newJRouteParams.size = sSize;
    if (sColor.length > 0) newJRouteParams.color = sColor;
    const newFilterString = JSON.stringify(newJRouteParams);
    const oldFilterString = sessionStorage.getItem("filter") || "";

    if (newFilterString === oldFilterString) return;

    sessionStorage.setItem("filter", newFilterString);
    setSortValues(newJRouteParams);
    sessionStorage.setItem("currentPage", 1);
    setCurrentPage(1);
    setRefresh(!refresh);
  }, [routeParams, query]);

  const getSortParams = (sortType, sortValue, type) => {
    const _sortValues = { ...sortValues };
    delete _sortValues[sortType];

    if (sortValue !== "all") {
      _sortValues[sortType] =
        type === "+"
          ? (sortValues[sortType] ? sortValues[sortType] + "|" : "") + sortValue
          : (sortValues[sortType] || "")
              .replace("|" + sortValue, "")
              .replace(sortValue + "|", "");
      if ((sortValues[sortType] || "") === sortValue)
        _sortValues[sortType] = (sortValues[sortType] || "").replace(
          sortValue,
          ""
        );
    }
    if (_sortValues[sortType] === "") delete _sortValues[sortType];

    let _sp = {};
    Object.keys(_sortValues).forEach((_e) => {
      if (_e) {
        _sp[_e] = _sortValues[_e].split("|");
      }
    });

    const newUrl = new URLSearchParams(_sp).toString();

    const baseURL =
      window.location.pathname.substring(0, 21) === "/shop-grid-full-width"
        ? "/shop-grid-full-width/"
        : "/consigliati/";
    console.log(name);
    //(name ? '?name=' + name : '') + '/';
    history.push(baseURL + newUrl);
    localStorage.setItem("currentPage", 1);
    /*
    setSortType(sortType);
    setSortValue(sortValue);
    var sortValuesLocal = sortValues;
    if (sortValuesLocal) sortValuesLocal[sortType] = sortValuesLocal[sortType] ? sortValuesLocal[sortType].replace("all", "") : ""
    if (sortValue == "all" && type == "+") sortValuesLocal[sortType] = "all"
    else if (type == "+") sortValuesLocal[sortType] = sortValuesLocal[sortType] ? sortValuesLocal[sortType] + "|" + sortValue : sortValue
    else if (type == "-") sortValuesLocal[sortType] = sortValuesLocal[sortType].replace("|" + sortValue, "").replace(sortValue + "|", "").replace(sortValue, "")
    if (sortValuesLocal[sortType] == "") delete sortValuesLocal[sortType]

    sessionStorage.setItem("filter", JSON.stringify(sortValuesLocal))
    console.log(sortValuesLocal)

    setSortValues(sortValuesLocal)
    setRefresh(!refresh)
    sessionStorage.setItem("currentPage", 1)
    setCurrentPage(1)*/
  };

  const getFilterSortParams = (sortType, sortValue) => {
    setFilterSortType(sortType);
    setFilterSortValue(sortValue);
  };

  useEffect(() => {
    if (global.inManutenzione) {
      //setShowDialogUpdate(false)
      return;
    }
    setPromo(localStorage.getItem("promo") === "SI");
    localStorage.setItem("promo", "NO");

    const time = Date.now() - sessionStorage.getItem("lastRefresh");
    //if (Date.now() - sessionStorage.getItem("lastRefresh") > global.thrUpdPro) {
    if (
      (userData.user.user &&
        (userData.user.user.IDCli || userData.user.user.IDAge)) ||
      prodottiSenzaLogin
    ) {
      var credentials = {};
      var username = "";
      var password = "";

      if (
        userData.user.user &&
        (userData.user.user.IDCli || userData.user.user.IDAge)
      ) {
        var username = userData.user.user.username;
        var password = userData.user.user.password;
        credentials = { username, password };
      }

      var risultatoProducts = fetchProductsNoResult({
        ...credentials,
        recommended: userData?.user?.user?.jsonVendite,
      });

      //saveProducts(risultatoProducts, addToast)
      risultatoProducts
        .then((res) => res.json())
        .then((result) => {
          if (!result.items) {
            try {
              const recommended = userData?.user.user?.jsonVendite
                ? userData?.user.user?.jsonVendite
                : [];
              const itemsFromAPI = JSON.parse(result?.itemsNoParsed);
              var recommendedProducts = !recommended
                ? undefined
                : recommended
                    .map(
                      (_r) =>
                        itemsFromAPI?.find(
                          (_item) => _item.id === _r.idArtBas
                        ) || null
                    )
                    .filter((_rr) => !!_rr?.id);
              if (recommendedProducts)
                recommendedProducts = recommendedProducts.map((_r) => {
                  _r.recommended = true;
                  return _r;
                });
              result.items = !recommended
                ? [...itemsFromAPI]
                : [...recommendedProducts, ...itemsFromAPI];
              result.items = result.items.reduce((acc, current) => {
                if (!acc.some((item) => item.id === current.id)) {
                  acc.push(current);
                }
                return acc;
              }, []);
              result.itemsNoParsed = "";
              result.itemsDescription = JSON.parse(
                result?.itemsDescriptionNoParsed
              );
              result.itemsDescriptionNoParsed = "";
              result.itemsNoSco = result?.itemsNoSco;
            } catch (error) {
              console.log(error);
            }
          }

          sessionStorage.setItem("lastRefresh", Date.now());
          //console.log(result)
          //console.log(result)
          dispatch(saveProducts(result, addToast));
          //closeDialogUpdate()
        });
    } else {
      var risultatoProducts = fetchProductsNoResult({});
      //saveProducts(risultatoProducts, addToast)
      risultatoProducts
        .then((res) => res.json())
        .then((result) => {
          if (!result.items) {
            try {
              const recommended = userData?.user.user?.jsonVendite
                ? userData?.user.user?.jsonVendite
                : [];
              const itemsFromAPI = JSON.parse(result?.itemsNoParsed);
              var recommendedProducts = !recommended
                ? undefined
                : recommended
                    .map(
                      (_r) =>
                        itemsFromAPI?.find(
                          (_item) => _item.id === _r.idArtBas
                        ) || null
                    )
                    .filter((_rr) => !!_rr?.id);
              if (recommendedProducts)
                recommendedProducts = recommendedProducts.map((_r) => {
                  _r.recommended = true;
                  return _r;
                });
              result.items = !recommended
                ? [...itemsFromAPI]
                : [...recommendedProducts, ...itemsFromAPI];
              result.itemsNoParsed = "";
              result.itemsDescription = JSON.parse(
                result?.itemsDescriptionNoParsed
              );
              result.itemsDescriptionNoParsed = "";
              result.itemsNoSco = result?.itemsNoSco;
            } catch (error) {
              console.log(error);
            }
          }

          sessionStorage.setItem("lastRefresh", Date.now());
          //console.log(result)
          //console.log(result)
          dispatch(saveProducts(result, addToast));
          //closeDialogUpdate()
        });
    }
    /*}
    else {
      //closeDialogUpdate()
    }*/
    const timer = setInterval(() => {
      if (
        (userData.user.user &&
          (userData.user.user.IDCli || userData.user.user.IDAge)) ||
        prodottiSenzaLogin
      ) {
        //setShowDialogUpdate(true);
        var credentials = {};
        var username = "";
        var password = "";

        if (
          userData.user.user &&
          (userData.user.user.IDCli || userData.user.user.IDAge)
        ) {
          var username = userData.user.user.username;
          var password = userData.user.user.password;
          credentials = { username, password };
        }

        var risultatoProducts = fetchProductsNoResult({
          ...credentials,
          recommended: userData?.user?.user?.jsonVendite,
        });
        //console.log(risultatoProducts)
        risultatoProducts
          .then((res) => res.json())
          .then((result) => {
            if (!result.items) {
              try {
                const recommended = userData?.user.user?.jsonVendite
                  ? userData?.user.user?.jsonVendite
                  : [];
                const itemsFromAPI = JSON.parse(result?.itemsNoParsed);
                var recommendedProducts = !recommended
                  ? undefined
                  : recommended
                      .map(
                        (_r) =>
                          itemsFromAPI?.find(
                            (_item) => _item.id === _r.idArtBas
                          ) || null
                      )
                      .filter((_rr) => !!_rr?.id);
                if (recommendedProducts)
                  recommendedProducts = recommendedProducts.map((_r) => {
                    _r.recommended = true;
                    return _r;
                  });
                result.items = !recommended
                  ? [...itemsFromAPI]
                  : [...recommendedProducts, ...itemsFromAPI];
                result.itemsNoParsed = "";
                result.itemsDescription = JSON.parse(
                  result?.itemsDescriptionNoParsed
                );
                result.itemsDescriptionNoParsed = "";
                result.itemsNoSco = JSON.parse(result?.itemsNoSco);
              } catch (error) {
                console.log(error);
              }
            }

            sessionStorage.setItem("lastRefresh", Date.now());
            //console.log(result)
            //console.log(result)
            dispatch(saveProducts(result, addToast));
            //closeDialogUpdate()
          });
      } else {
        var risultatoProducts = fetchProductsNoResult({});
        //console.log(risultatoProducts)
        risultatoProducts
          .then((res) => res.json())
          .then((result) => {
            if (!result.items) {
              try {
                const recommended = userData?.user.user?.jsonVendite
                  ? userData?.user.user?.jsonVendite
                  : [];
                const itemsFromAPI = JSON.parse(result?.itemsNoParsed);
                var recommendedProducts = !recommended
                  ? undefined
                  : recommended
                      .map(
                        (_r) =>
                          itemsFromAPI?.find(
                            (_item) => _item.id === _r.idArtBas
                          ) || null
                      )
                      .filter((_rr) => !!_rr?.id);
                if (recommendedProducts)
                  recommendedProducts = recommendedProducts.map((_r) => {
                    _r.recommended = true;
                    return _r;
                  });
                result.items = !recommended
                  ? [...itemsFromAPI]
                  : [...recommendedProducts, ...itemsFromAPI];
                result.itemsNoParsed = "";
                result.itemsDescription = JSON.parse(
                  result?.itemsDescriptionNoParsed
                );
                result.itemsDescriptionNoParsed = "";
                result.itemsNoSco = JSON.parse(result?.itemsNoSco);
              } catch (error) {
                console.log(error);
              }
            }

            sessionStorage.setItem("lastRefresh", Date.now());
            ////console.log(result)
            //console.log(result)
            dispatch(saveProducts(result, addToast));
            //closeDialogUpdate()
          });
      }
    }, global.thrUpdPro);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const isConsigliati = !(
      window.location.pathname.substring(0, 21) === "/shop-grid-full-width"
    ); //window.location.pathname === '/consigliati' ? true : false;
    const _cp = localStorage.getItem("currentPage")
      ? parseInt(localStorage.getItem("currentPage"))
      : 1;

    if (_cp != currentPage) {
      setCurrentPage(_cp);
    }
    const product6 =
      products && products.length >= 200 ? products?.slice(0, 200) : products;
    const _products = isConsigliati ? product6 : products;
    let sortedProducts = getSortedProductsNew(_products, sortValues);
    const filterSortedProducts = getSortedProducts(
      sortedProducts,
      filterSortType,
      filterSortValue
    );
    sortedProducts = promo
      ? filterSortedProducts.filter((c) => c.altdat3 === "1")
      : filterSortedProducts;
    setSortedProducts(sortedProducts);
    try {
      setCurrentData(sortedProducts?.slice(offset, offset + pageLimit));
    } catch (error) {
      console.log(error);
    }
  }, [
    offset,
    products,
    sortType,
    sortValue,
    filterSortType,
    filterSortValue,
    sortValues,
    refresh,
  ]);

  useEffect(() => {
    if (name != null && name != "") {
      setFilterSortType("name, sku");
      if (global.aziendaID == 4) setFilterSortType("name, sku, codAlt");
      setFilterSortValue(name);
      sessionStorage.setItem("currentPage", 1);
      setCurrentPage(1);
    }
    setSortValues(
      JSON.parse(sessionStorage.getItem("filter"))
        ? JSON.parse(sessionStorage.getItem("filter"))
        : {}
    );
    setRefresh(!refresh);
  }, []);

  var informazioni = global.informazioni;

  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.shop} | {informazioni.società}
        </title>
        <meta
          name="description"
          content={strings.shop + " " + informazioni.società}
        />
      </MetaTags>

      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        Acquista
      </BreadcrumbsItem>
      {/*<ModalUpdate />*/}
      {/*new Date(2023, 11, 1).getTime() > new Date().getTime() ? <ModalNovember8 /> : <ModalDecember8 />*/}

      <LayoutThree headerTop="invisible" getSortParams={getSortParams}>
        {/* breadcrumb */}

        <div className="shop-area pt-95 pb-100">
          <div className="container-fluid" style={{ paddingLeft: "20px" }}>
            <div className="row">
              {global.aziendaID != 4 && (
                <div
                  className="col-lg-2 order-2 order-lg-1"
                  style={{ overflowY: "auto", maxHeight: "830px" }}
                >
                  <div id={"filtri"}></div>

                  {/* shop sidebar */}

                  <ShopSidebar
                    products={products}
                    getSortParams={getSortParams}
                    setSortValues={setSortValues}
                    value={name}
                  />
                </div>
              )}
              <div
                className={
                  global.aziendaID != 4
                    ? "col-lg-10 order-1 order-lg-2"
                    : "col-lg-10 order-1 order-lg-2 offset-lg-1"
                }
              >
                {/* shop topbar default */}
                <ShopTopbar
                  setSortValues={setSortValues}
                  getSortParams={getSortParams}
                  value={name}
                  userData={userData}
                  getLayout={getLayout}
                  getFilterSortParams={getFilterSortParams}
                  productCount={sortedProducts.length}
                  sortedProductCount={currentData.length}
                  offset={offset}
                  sortValues={sortValues}
                />

                {global.aziendaID == 4 && sortValues.category && (
                  <div>
                    <Button onClick={() => history.goBack()}>
                      <ArrowBackIcon />
                    </Button>
                  </div>
                )}
                {((global.aziendaID == 4 && !sortValues.category && !name) ||
                  (global.aziendaID == 2 &&
                    sortValues.tag &&
                    !sortValues.category &&
                    !promo &&
                    !name)) && (
                  <ShopProductCategory
                    products={products}
                    getSortParams={getSortParams}
                    setSortValues={setSortValues}
                    value={name}
                    tag={sortValues.tag}
                    category={sortValues.category}
                  />
                )}
                {global.aziendaID == 4 &&
                  sortValues.category &&
                  !sortValues.subcategory && (
                    <ShopProductSubCategory
                      products={products}
                      category={sortValues.category}
                      getSortParams={getSortParams}
                      setSortValues={setSortValues}
                      value={name}
                    />
                  )}
                {global.aziendaID == 4 &&
                  sortValues.category &&
                  sortValues.subcategory &&
                  !sortValues.brands && (
                    <ShopProductBrands
                      products={products}
                      category={sortValues.category}
                      subcategory={sortValues.subcategory}
                      getSortParams={getSortParams}
                      setSortValues={setSortValues}
                      value={name}
                    />
                  )}
                {global.aziendaID == 2 &&
                  !sortValues.tag &&
                  !name &&
                  !promo &&
                  !(
                    sortValues.brands ||
                    sortValues.templates ||
                    sortValues.subcategory
                  ) &&
                  !(global.aziendaID == 2 && sortValues.category) && (
                    <ShopProductTag
                      products={products}
                      getSortParams={getSortParams}
                      setSortValues={setSortValues}
                      value={name}
                    />
                  )}
                {global.aziendaID == 2 &&
                  !sortValues.tag &&
                  !name &&
                  !promo &&
                  !(
                    sortValues.brands ||
                    sortValues.templates ||
                    sortValues.subcategory
                  ) &&
                  !(global.aziendaID == 2 && sortValues.category) &&
                  isLoggedUser && (
                    <Accordion>
                      <AccordionSummary
                        aria-controls="panel1-content"
                        id="panel1-header"
                      >
                        <Typography component="span">
                          <b>Ultimi articoli acquistati</b> <ExpandMoreIcon />
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <ShopProducts
                          isLoggedUser={isLoggedUser}
                          visualizzaPrezzi={visualizzaPrezzi}
                          layout={layout}
                          products={products.filter(
                            (p) => p.recommended == true
                          )}
                        />
                      </AccordionDetails>
                    </Accordion>
                  )}
                {global.aziendaID == 2 &&
                  sortValues.tag &&
                  sortValues.category && (
                    <div>
                      <Button onClick={() => history.goBack()}>
                        <ArrowBackIcon />
                      </Button>
                    </div>
                  )}
                {/* shop page content default */}
                {((global.aziendaID == 2 &&
                  sortValues.tag &&
                  sortValues.category) ||
                  (global.aziendaID == 2 && sortValues.category) ||
                  name ||
                  promo ||
                  (global.aziendaID == 2 &&
                    (sortValues.brands ||
                      sortValues.templates ||
                      sortValues.subcategory)) ||
                  global.aziendaID == 1 ||
                  global.aziendaID == 3 ||
                  (global.aziendaID == 4 && sortValues.category)) && (
                  <ShopProducts
                    isLoggedUser={isLoggedUser}
                    visualizzaPrezzi={visualizzaPrezzi}
                    layout={layout}
                    products={
                      promo
                        ? products.filter((c) => c.altdat3 === "1")
                        : currentData
                    }
                  />
                )}
                {/* shop product pagination */}
                {((global.aziendaID == 2 &&
                  sortValues.tag &&
                  sortValues.category) ||
                  (global.aziendaID == 2 && sortValues.category) ||
                  name ||
                  promo ||
                  (global.aziendaID == 2 &&
                    (sortValues.brands ||
                      sortValues.templates ||
                      sortValues.subcategory)) ||
                  global.aziendaID == 1 ||
                  global.aziendaID == 3 ||
                  (global.aziendaID == 4 && sortValues.category)) && (
                  <div className="pro-pagination-style text-center mt-30">
                    <Paginator
                      totalRecords={sortedProducts.length}
                      pageLimit={pageLimit}
                      pageNeighbours={2}
                      setOffset={setOffset}
                      currentPage={currentPage}
                      setCurrentPage={(page) => {
                        setCurrentPage(page);
                        localStorage.setItem("currentPage", page);
                        animateScroll.scrollToTop();
                        document
                          .getElementById("products-area")
                          .scrollTo({ top: 0, behavior: "smooth" });
                      }}
                      pageContainerClass="mb-0 mt-0"
                      pagePrevText="«"
                      pageNextText="»"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </LayoutThree>
    </Fragment>
  );
};

ShopGridFullWidth.propTypes = {
  location: PropTypes.object,
  products: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    products: state.productData.products,
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user, addToast) => {
      dispatch(saveUser(user, addToast));
    },
    saveProducts: (products, addToast) => {
      dispatch(saveProducts(products, addToast));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ShopGridFullWidth);
